const module = { name: 'shared/utils/objUtils', exports: {} }; const exports = module.exports;



import { Fandango_sanitizer as Fandango_sanitizer_isPlainObject } from 'require-core';

const { isPlainObject } = Fandango_sanitizer_isPlainObject;


import { Fandango_debugLog as debugLog } from 'require-core';

function clone(source) {
    if (!isPlainObject(source)) {
        return null;
    }
    try {
        return JSON.parse(JSON.stringify(source));
    }
    catch (error) {
        return null;
    }
}
function pick(source, props) {
    if (!isPlainObject(source)) {
        return {};
    }
    if (arguments.length > 2) {
        props = Array.from(arguments).slice(1);
    }
    else if (typeof props === 'string') {
        props = props.split(',');
    }
    else if (!Array.isArray(props)) {
        debugLog.error(`${module.name}.pick "props" must be an array or string`);
        return {};
    }
    return props
        .map(key => typeof key === 'string' ? key.trim() : '')
        .filter(key => key && Object.prototype.hasOwnProperty.call(source, key))
        .reduce((target, key) => {
        target[key] = source[key];
        return target;
    }, {});
}
module.exports = {
    clone,
    pick,
};
export default module.exports;